import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.featured-service-categories__splide' ).each( function( index, element ) {
        const slider = new Splide( element, {
          type: 'loop',
          gap: '2rem',
          perPage: 3,
          focus: 'center',
          perMove: 1,
          pagination: false,
          arrows: true,
          speed: 800,
          breakpoints: {
            1270: {
              perPage: 2,
              focus: 'left',
            },
            768: {
              perPage: 1,
              gap: '1rem',
              focus: 'center',
            },
          },
        } );

        slider.on( 'overflow', function( isOverflow ) {
          if ( !isOverflow ) {
            slider.options = {
              arrows: isOverflow,
              pagination: isOverflow,
              drag: isOverflow,
              clones: isOverflow ? undefined : 0,
              focus: 0,
            };
          }
        } );

        slider.on( 'mounted', function() {
          console.log( 'hi' );
          cardContentPositioning();
        } );
        slider.mount();
      } );

      $( window ).on( 'resize', function() {
        cardContentPositioning();
      } );
      function cardContentPositioning() {
        if ( window.innerWidth > 1024 ) {
          $( '.featured-service-categories__card-content' ).each( function() {
            const hoverContent = $( this ).find( '.featured-service-categories__hover-content' );
            const descriptionHeight = $( hoverContent ).outerHeight();

            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(${descriptionHeight}px)`,
            } );

            // Force a reflow before adding the transition to prevent jumping on load
            // and don't add it if prefers reduced motion is true
            if ( window.hasMotion ) {
              requestAnimationFrame( () => {
                $( this ).css( 'transition-duration', '0.5s' );
              } );
            }
          } );
        } else {
          $( '.featured-service-categories__card-content' ).each( function() {
            $( this ).css( {
              'opacity': '1',
              'transform': `translateY(0px)`,
            } );
          } );
        }
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'featured-service-categories', COMPONENT );
} )( app );
